import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const homeFor = (u) => {
  if (!u) return "/login";
  if (u.platform_role === "superadmin" && !u.impersonating) return "/super";
  if (u.tenant_role === "admin") return "/app";
  return "/me";
};

export function AuthProvider({ children }) {
  const [user, setUserState] = useState(null);
  const seq = useRef(0);
  const setUser = useCallback((u) => {
    seq.current += 1;
    setUserState(u);
  }, []);

  const refresh = useCallback(async () => {
    const mine = ++seq.current;
    try {
      const { data } = await api.get("/auth/me");
      if (mine === seq.current) setUserState(data);
      return data;
    } catch (e) {
      if (mine === seq.current) setUserState(false);
      return false;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, refresh, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
